/**
 * Request email modal: open on "Request email back" button click, submit to HubSpot.
 * Uses same HubSpot portal and form as request-callback (portal 7860975, form ce2ea945-...).
 * Payload: firstname, email, message (phone empty for this form).
 */
(function () {
  const MODAL_ID = 'request-email-modal';
  const FORM_ID = 'request-email-form';
  const SUCCESS_ID = 'request-email-success';
  const TRIGGER_TEXT = 'Request email back';
  const HUBSPOT_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/7860975/ce2ea945-3164-4eb7-a579-2203ecb47b26';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function resetModalState() {
    var form = document.getElementById(FORM_ID);
    var successEl = document.getElementById(SUCCESS_ID);
    if (form) {
      form.hidden = false;
      form.reset();
    }
    if (successEl) successEl.hidden = true;
  }

  function openModal(e) {
    var modal = getModal();
    if (modal && typeof modal.showDialog === 'function') {
      e.preventDefault();
      e.stopPropagation();
      resetModalState();
      modal.showDialog();
    }
  }

  function isRequestEmailTrigger(el) {
    if (!el || !(el instanceof HTMLElement)) return false;
    if (el.hasAttribute('data-request-email-trigger')) return true;
    var tag = el.tagName && el.tagName.toLowerCase();
    if (tag !== 'a' && tag !== 'button') return false;
    var text = (el.textContent || '').trim();
    return text === TRIGGER_TEXT;
  }

  function handleDocumentClick(e) {
    var target = e.target.closest('a, button');
    if (target && target.closest('#' + MODAL_ID)) return;
    if (target && isRequestEmailTrigger(target)) {
      openModal(e);
    }
  }

  function buildHubSpotPayload(form) {
    var nameEl = form.querySelector('#request-email-name');
    var emailEl = form.querySelector('#request-email-email');
    var phoneEl = form.querySelector('#request-email-phone');
    var messageEl = form.querySelector('#request-email-message');
    var name = (nameEl && nameEl.value) ? nameEl.value.trim() : '';
    var email = (emailEl && emailEl.value) ? emailEl.value.trim() : '';
    var phone = (phoneEl && phoneEl.value) ? phoneEl.value.trim() : '';
    var message = (messageEl && messageEl.value) ? messageEl.value.trim() : '';
    var fields = [
      { name: 'firstname', value: name },
      { name: 'email', value: email },
      { name: 'mobilephone', value: phone },
      { name: 'message', value: message }
    ];
    return {
      fields: fields,
      context: getPageContext()
    };
  }

  function getFieldValue(form, selector) {
    var field = form.querySelector(selector);
    if (!field || typeof field.value !== 'string') return '';
    return field.value.trim();
  }

  function getPageContext() {
    var pageUri = typeof window !== 'undefined' && window.location ? window.location.href : '';
    var pageName = '';
    if (typeof window !== 'undefined' && window.location) {
      pageName = (window.location.pathname || '') + (window.location.search || '');
    }
    if (!pageName) {
      pageName = typeof document !== 'undefined' && document.title ? document.title.trim() : 'Website enquiry';
    }
    var hutk = '';
    if (typeof document !== 'undefined' && typeof document.cookie === 'string') {
      var match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      var hutkValue = match && match[1] ? match[1] : '';
      hutk = hutkValue ? decodeURIComponent(hutkValue) : '';
    }
    var context = {
      pageUri: pageUri,
      pageName: pageName
    };
    if (hutk) context.hutk = hutk;
    return context;
  }

  function showSuccess(formEl, successEl) {
    if (formEl) formEl.hidden = true;
    if (successEl) successEl.hidden = false;
  }

  function closeModalSoon(modal) {
    if (modal && typeof modal.closeDialog === 'function') {
      setTimeout(function () { modal.closeDialog(); }, 2000);
    }
  }

  function handleSubmit(e) {
    var form = document.getElementById(FORM_ID);
    var successEl = document.getElementById(SUCCESS_ID);
    var modal = getModal();

    if (!form) return;

    e.preventDefault();

    var emailValue = getFieldValue(form, '#request-email-email');
    if (!emailValue) {
      alert('Please enter your email address.');
      return;
    }

    var payload = buildHubSpotPayload(form);

    fetch(HUBSPOT_SUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.ok) return res;
        return res.text().then(function (text) {
          throw new Error('HubSpot submission failed (' + res.status + '): ' + text);
        });
      })
      .then(function () {
        showSuccess(form, successEl);
        closeModalSoon(modal);
      })
      .catch(function (err) {
        console.error(err);
        alert('Sorry — we could not send your message. Please try again.');
      });
  }

  function init() {
    document.body.addEventListener('click', handleDocumentClick, true);

    var form = document.getElementById(FORM_ID);
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    var modal = getModal();
    if (modal) {
      modal.addEventListener('dialog:open', resetModalState);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
